import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
// Add CSS variables for brand colors
const styleElement = document.createElement('style');
styleElement.textContent = `
:root {
  --maxw: 1200px;
}
html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
}
`;
document.head.appendChild(styleElement);
// Set html lang attribute for SEO
document.documentElement.lang = 'en';
// Set page title (Yoast: 50-60 chars, primary keyword first)
document.title = 'Aircraft Management & CAMO Services Singapore | Cosmo Image Aviation';
// ===== PRECONNECT & DNS-PREFETCH (Performance + SEO) =====
const preconnects = ['https://cdn.magicpatterns.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://cdnjs.cloudflare.com', 'https://a.basemaps.cartocdn.com', 'https://b.basemaps.cartocdn.com', 'https://c.basemaps.cartocdn.com'];
preconnects.forEach(url => {
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = url;
  preconnect.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect);
  const dnsPrefetch = document.createElement('link');
  dnsPrefetch.rel = 'dns-prefetch';
  dnsPrefetch.href = url;
  document.head.appendChild(dnsPrefetch);
});
// Add viewport meta tag for responsive design
const viewportMeta = document.createElement('meta');
viewportMeta.name = 'viewport';
viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=5.0';
document.head.appendChild(viewportMeta);
// Add charset
const charsetMeta = document.createElement('meta');
charsetMeta.setAttribute('charset', 'UTF-8');
document.head.appendChild(charsetMeta);
// ===== HTTP-EQUIV META TAGS =====
const httpEquivTags = [{
  'http-equiv': 'X-UA-Compatible',
  content: 'IE=edge'
}, {
  'http-equiv': 'content-language',
  content: 'en'
}];
httpEquivTags.forEach(tag => {
  const meta = document.createElement('meta');
  meta.setAttribute('http-equiv', tag['http-equiv']);
  meta.content = tag.content;
  document.head.appendChild(meta);
});
// Add theme color (matches brand navy)
const themeColorMeta = document.createElement('meta');
themeColorMeta.name = 'theme-color';
themeColorMeta.content = '#0A1628';
document.head.appendChild(themeColorMeta);
// Comprehensive meta tags for SEO (Yoast-optimized)
const metaTags = [
// Primary meta description (Yoast: 120-155 chars, include CTA)
{
  name: 'description',
  content: 'Cosmo Image Aviation: aircraft management, CAMO services & charter solutions in Singapore. Safety, compliance & operational excellence.'
},
// Keywords (supplementary, not primary ranking factor)
{
  name: 'keywords',
  content: 'aircraft management Indonesia, CAMO services, continuing airworthiness management, aircraft charter Indonesia, aviation management company, aircraft operations, flight management, aircraft maintenance oversight, aviation compliance, Cosmo Image Aviation'
}, {
  name: 'author',
  content: 'COSMO IMAGE AVIATION PTE. LTD.'
},
// Robots directives (Yoast-style comprehensive)
{
  name: 'robots',
  content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
}, {
  name: 'googlebot',
  content: 'index, follow'
}, {
  name: 'bingbot',
  content: 'index, follow'
},
// Language & Geo
{
  name: 'language',
  content: 'English'
}, {
  name: 'geo.region',
  content: 'SG'
}, {
  name: 'geo.placename',
  content: 'Singapore'
}, {
  name: 'geo.position',
  content: '1.297;103.8536'
}, {
  name: 'ICBM',
  content: '1.297, 103.8536'
},
// Revisit & Rating
{
  name: 'revisit-after',
  content: '7 days'
}, {
  name: 'rating',
  content: 'general'
}, {
  name: 'referrer',
  content: 'no-referrer-when-downgrade'
},
// Mobile app meta
{
  name: 'format-detection',
  content: 'telephone=no'
}, {
  name: 'apple-mobile-web-app-capable',
  content: 'yes'
}, {
  name: 'apple-mobile-web-app-title',
  content: 'Cosmo Image Aviation'
}, {
  name: 'apple-mobile-web-app-status-bar-style',
  content: 'black-translucent'
}, {
  name: 'msapplication-TileColor',
  content: '#0A1628'
}, {
  name: 'msapplication-navbutton-color',
  content: '#0A1628'
},
// ===== OPEN GRAPH (Facebook, LinkedIn, WhatsApp, Telegram) =====
{
  property: 'og:site_name',
  content: 'Cosmo Image Aviation'
}, {
  property: 'og:title',
  content: 'Aircraft Management & CAMO Services Singapore | Cosmo Image Aviation'
}, {
  property: 'og:description',
  content: 'Professional aircraft management, continuing airworthiness (CAMO), and charter solutions. Trusted aviation partner serving Indonesia and the region.'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:url',
  content: 'https://www.cosmoimageaviation.com/'
}, {
  property: 'og:image',
  content: 'https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png'
}, {
  property: 'og:image:secure_url',
  content: 'https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png'
}, {
  property: 'og:image:type',
  content: 'image/png'
}, {
  property: 'og:image:width',
  content: '1200'
}, {
  property: 'og:image:height',
  content: '630'
}, {
  property: 'og:image:alt',
  content: 'Cosmo Image Aviation - Aircraft Management & CAMO Services'
}, {
  property: 'og:locale',
  content: 'en_SG'
}, {
  property: 'og:locale:alternate',
  content: 'en_US'
}, {
  property: 'og:locale:alternate',
  content: 'en_GB'
},
// Facebook App ID (replace with actual if available)
// { property: 'fb:app_id', content: 'YOUR_FB_APP_ID' },
// ===== TWITTER CARD =====
{
  name: 'twitter:card',
  content: 'summary_large_image'
}, {
  name: 'twitter:site',
  content: '@cosmoimageaviation'
}, {
  name: 'twitter:creator',
  content: '@cosmoimageaviation'
}, {
  name: 'twitter:title',
  content: 'Aircraft Management & CAMO Services Singapore | Cosmo Image Aviation'
}, {
  name: 'twitter:description',
  content: 'Professional aircraft management, CAMO services, and charter solutions. Trusted aviation partner across Indonesia and the region.'
}, {
  name: 'twitter:image',
  content: 'https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png'
}, {
  name: 'twitter:image:alt',
  content: 'Cosmo Image Aviation Logo'
},
// ===== PINTEREST =====
{
  name: 'pinterest-rich-pin',
  content: 'true'
}];
// Add canonical link
const canonicalLink = document.createElement('link');
canonicalLink.rel = 'canonical';
canonicalLink.href = 'https://www.cosmoimageaviation.com/';
document.head.appendChild(canonicalLink);
// Add alternate language link
const alternateLinkEN = document.createElement('link');
alternateLinkEN.rel = 'alternate';
alternateLinkEN.hreflang = 'en';
alternateLinkEN.href = 'https://www.cosmoimageaviation.com/';
document.head.appendChild(alternateLinkEN);
// x-default hreflang
const alternateDefault = document.createElement('link');
alternateDefault.rel = 'alternate';
alternateDefault.hreflang = 'x-default';
alternateDefault.href = 'https://www.cosmoimageaviation.com/';
document.head.appendChild(alternateDefault);
// Add meta tags to head
metaTags.forEach(meta => {
  const metaElement = document.createElement('meta');
  const key = (meta as any).property ? 'property' : 'name';
  metaElement.setAttribute(key, (meta as any)[key]);
  metaElement.setAttribute('content', meta.content);
  document.head.appendChild(metaElement);
});
// ===== STRUCTURED DATA (JSON-LD) =====
// 1. Organization Schema (primary)
const organizationData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://www.cosmoimageaviation.com/#organization',
  name: 'COSMO IMAGE AVIATION PTE. LTD.',
  legalName: 'COSMO IMAGE AVIATION PTE. LTD.',
  url: 'https://www.cosmoimageaviation.com/',
  logo: {
    '@type': 'ImageObject',
    url: 'https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png',
    width: 600,
    height: 200
  },
  foundingDate: '2023-03-30',
  description: 'Aviation services company specializing in aircraft management, continuing airworthiness management (CAMO), and charter solutions across Indonesia and the region.',
  slogan: 'Professional Aviation Solutions You Can Trust',
  address: [{
    '@type': 'PostalAddress',
    name: 'Head Office',
    streetAddress: '1 Liang Seah Street, #02-02',
    addressLocality: 'Singapore',
    postalCode: '189022',
    addressCountry: 'SG'
  }, {
    '@type': 'PostalAddress',
    name: 'Airport Warehouse',
    streetAddress: '115 Airport Cargo Road, #01-01 & #01-06, Cargo Agents Building C',
    addressLocality: 'Singapore',
    postalCode: '819466',
    addressCountry: 'SG'
  }],
  contactPoint: [{
    '@type': 'ContactPoint',
    telephone: '+65-8126-6622',
    contactType: 'Customer Service',
    areaServed: ['ID', 'SG', 'MY', 'TH', 'PH', 'VN'],
    availableLanguage: ['English', 'Indonesian'],
    contactOption: 'TollFree'
  }, {
    '@type': 'ContactPoint',
    telephone: '+65-8126-6622',
    contactType: 'Sales',
    areaServed: ['ID', 'SG', 'APAC'],
    availableLanguage: ['English']
  }],
  email: 'contact@cosmoimageaviation.co',
  telephone: '+65-8126-6622',
  faxNumber: '+65-6234-3152',
  sameAs: ['https://www.linkedin.com/company/cosmoimageaviation', 'https://www.facebook.com/cosmoimageaviation', 'https://twitter.com/cosmoimageaviation', 'https://www.instagram.com/cosmoimageaviation'],
  knowsAbout: ['Aircraft Management', 'Continuing Airworthiness Management', 'CAMO Services', 'Aircraft Charter', 'Aviation Compliance', 'Flight Operations', 'Aircraft Maintenance Oversight', 'Aviation Safety'],
  makesOffer: [{
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name: 'Aircraft Management',
      description: 'End-to-end aircraft management including crew management, flight planning, maintenance coordination, financial oversight, and regulatory compliance.',
      provider: {
        '@id': 'https://www.cosmoimageaviation.com/#organization'
      },
      areaServed: 'Asia-Pacific',
      serviceType: 'Aircraft Management'
    }
  }, {
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name: 'CAMO Services',
      description: 'Continuing Airworthiness Management Organization services including airworthiness reviews, maintenance program management, AD/SB compliance tracking, and technical records management.',
      provider: {
        '@id': 'https://www.cosmoimageaviation.com/#organization'
      },
      areaServed: 'Asia-Pacific',
      serviceType: 'Continuing Airworthiness Management'
    }
  }, {
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name: 'Aircraft Charter',
      description: 'Flexible charter solutions providing access to business jets and turboprops for corporate travel, special missions, and ad-hoc requirements across the Asia-Pacific region.',
      provider: {
        '@id': 'https://www.cosmoimageaviation.com/#organization'
      },
      areaServed: 'Asia-Pacific',
      serviceType: 'Aircraft Charter'
    }
  }]
};
const orgScript = document.createElement('script');
orgScript.type = 'application/ld+json';
orgScript.textContent = JSON.stringify(organizationData);
document.head.appendChild(orgScript);
// 2. WebSite Schema (with SearchAction for Google Sitelinks)
const websiteData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'https://www.cosmoimageaviation.com/#website',
  name: 'Cosmo Image Aviation',
  alternateName: 'COSMO IMAGE AVIATION PTE. LTD.',
  url: 'https://www.cosmoimageaviation.com/',
  publisher: {
    '@id': 'https://www.cosmoimageaviation.com/#organization'
  },
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://www.cosmoimageaviation.com/?s={search_term_string}'
    },
    'query-input': 'required name=search_term_string'
  }
};
const websiteScript = document.createElement('script');
websiteScript.type = 'application/ld+json';
websiteScript.textContent = JSON.stringify(websiteData);
document.head.appendChild(websiteScript);
// 3. WebPage Schema (main page)
const webPageData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': 'https://www.cosmoimageaviation.com/#webpage',
  url: 'https://www.cosmoimageaviation.com/',
  name: 'Aircraft Management & CAMO Services Singapore | Cosmo Image Aviation',
  description: 'Professional aircraft management, continuing airworthiness (CAMO), and charter solutions. Trusted aviation partner serving Indonesia and the region.',
  isPartOf: {
    '@id': 'https://www.cosmoimageaviation.com/#website'
  },
  about: {
    '@id': 'https://www.cosmoimageaviation.com/#organization'
  },
  primaryImageOfPage: {
    '@type': 'ImageObject',
    url: 'https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png'
  },
  datePublished: '2023-03-30',
  dateModified: '2026-03-12',
  inLanguage: 'en',
  breadcrumb: {
    '@id': 'https://www.cosmoimageaviation.com/#breadcrumb'
  }
};
const webPageScript = document.createElement('script');
webPageScript.type = 'application/ld+json';
webPageScript.textContent = JSON.stringify(webPageData);
document.head.appendChild(webPageScript);
// 4. ProfessionalService Schema (more specific than LocalBusiness for service companies)
const professionalServiceData = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': 'https://www.cosmoimageaviation.com/#professionalservice',
  name: 'COSMO IMAGE AVIATION PTE. LTD.',
  image: 'https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png',
  url: 'https://www.cosmoimageaviation.com/',
  telephone: '+65-8126-6622',
  email: 'contact@cosmoimageaviation.co',
  description: 'Professional aviation services company providing aircraft management, CAMO (Continuing Airworthiness Management Organization) services, and charter solutions across Indonesia and the Asia-Pacific region.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1 Liang Seah Street, #02-02',
    addressLocality: 'Singapore',
    postalCode: '189022',
    addressCountry: 'SG'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 1.297,
    longitude: 103.8536
  },
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '18:00'
  }],
  priceRange: '$$$',
  currenciesAccepted: 'SGD, USD, IDR',
  paymentAccepted: 'Bank Transfer, Wire Transfer',
  areaServed: [{
    '@type': 'Country',
    name: 'Indonesia'
  }, {
    '@type': 'Country',
    name: 'Singapore'
  }, {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: 1.297,
      longitude: 103.8536
    },
    geoRadius: '5000 km',
    description: 'Asia-Pacific Region'
  }],
  hasMap: 'https://maps.google.com/?q=1+Liang+Seah+Street+Singapore+189022',
  parentOrganization: {
    '@id': 'https://www.cosmoimageaviation.com/#organization'
  }
};
const professionalServiceScript = document.createElement('script');
professionalServiceScript.type = 'application/ld+json';
professionalServiceScript.textContent = JSON.stringify(professionalServiceData);
document.head.appendChild(professionalServiceScript);
// 5. LocalBusiness Schema (Google Maps & local SEO)
const localBusinessData = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': 'https://www.cosmoimageaviation.com/#localbusiness',
  name: 'COSMO IMAGE AVIATION PTE. LTD.',
  image: 'https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png',
  url: 'https://www.cosmoimageaviation.com/',
  telephone: '+65-8126-6622',
  email: 'contact@cosmoimageaviation.co',
  description: 'Aircraft management, CAMO services, and charter solutions provider serving Indonesia and the region.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1 Liang Seah Street, #02-02',
    addressLocality: 'Singapore',
    postalCode: '189022',
    addressCountry: 'SG'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 1.297,
    longitude: 103.8536
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '18:00'
  },
  priceRange: '$$$',
  hasMap: 'https://maps.google.com/?q=1+Liang+Seah+Street+Singapore+189022',
  parentOrganization: {
    '@id': 'https://www.cosmoimageaviation.com/#organization'
  }
};
const localBusinessScript = document.createElement('script');
localBusinessScript.type = 'application/ld+json';
localBusinessScript.textContent = JSON.stringify(localBusinessData);
document.head.appendChild(localBusinessScript);
// 6. SiteNavigationElement Schema (helps Google understand site structure)
const siteNavData = {
  '@context': 'https://schema.org',
  '@type': 'SiteNavigationElement',
  name: ['Home', 'About Us', 'Services', 'Fleet Access', 'Contact', 'Super Platform AI', 'Quasar', 'UDSA'],
  url: ['https://www.cosmoimageaviation.com/', 'https://www.cosmoimageaviation.com/#about', 'https://www.cosmoimageaviation.com/#services', 'https://www.cosmoimageaviation.com/#fleet', 'https://www.cosmoimageaviation.com/#contact', 'https://www.cosmoimageaviation.com/super-platform-ai', 'https://www.cosmoimageaviation.com/quasar', 'https://www.cosmoimageaviation.com/udsa']
};
const siteNavScript = document.createElement('script');
siteNavScript.type = 'application/ld+json';
siteNavScript.textContent = JSON.stringify(siteNavData);
document.head.appendChild(siteNavScript);
// 7. BreadcrumbList Schema
const breadcrumbData = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  '@id': 'https://www.cosmoimageaviation.com/#breadcrumb',
  itemListElement: [{
    '@type': 'ListItem',
    position: 1,
    name: 'Home',
    item: 'https://www.cosmoimageaviation.com/'
  }]
};
const breadcrumbScript = document.createElement('script');
breadcrumbScript.type = 'application/ld+json';
breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
document.head.appendChild(breadcrumbScript);
// 8. FAQPage Schema (boosts rich snippets in search)
const faqData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [{
    '@type': 'Question',
    name: 'What aircraft management services does Cosmo Image Aviation provide?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'We provide end-to-end aircraft management including operational oversight, crew management, flight planning & scheduling, maintenance coordination, financial management & cost reporting, and full regulatory compliance.'
    }
  }, {
    '@type': 'Question',
    name: 'What are CAMO services?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'CAMO (Continuing Airworthiness Management Organization) services ensure your aircraft meets all regulatory requirements. This includes airworthiness reviews & documentation, maintenance program management, AD & SB compliance tracking, regulatory liaison & reporting, and technical records management.'
    }
  }, {
    '@type': 'Question',
    name: 'Does Cosmo Image Aviation offer aircraft charter services?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Yes, we offer flexible charter solutions providing access to business jets and turboprops for corporate travel, special missions, and ad-hoc requirements across the Asia-Pacific region.'
    }
  }, {
    '@type': 'Question',
    name: 'Where is Cosmo Image Aviation located?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Our head office is located at 1 Liang Seah Street, #02-02, Singapore 189022. We also have an airport warehouse at 115 Airport Cargo Road, Cargo Agents Building C, Singapore 819466.'
    }
  }, {
    '@type': 'Question',
    name: 'What regions does Cosmo Image Aviation serve?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'We primarily serve Indonesia and the broader Asia-Pacific region, including Singapore, Malaysia, Thailand, Philippines, and Vietnam. Our services are designed to meet international aviation standards.'
    }
  }, {
    '@type': 'Question',
    name: 'How can I contact Cosmo Image Aviation?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'You can reach us by phone at +65 8126 6622, email at contact@cosmoimageaviation.co, or visit our head office at 1 Liang Seah Street, #02-02, Singapore 189022. You can also reach us via WhatsApp.'
    }
  }]
};
const faqScript = document.createElement('script');
faqScript.type = 'application/ld+json';
faqScript.textContent = JSON.stringify(faqData);
document.head.appendChild(faqScript);
// 9. Service Schema (standalone for rich results)
const serviceSchemas = [{
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': 'https://www.cosmoimageaviation.com/#aircraft-management',
  name: 'Aircraft Management Services',
  description: 'Comprehensive aircraft management including operational oversight, crew management, flight planning, maintenance coordination, financial management, and regulatory compliance.',
  provider: {
    '@id': 'https://www.cosmoimageaviation.com/#organization'
  },
  areaServed: {
    '@type': 'Place',
    name: 'Asia-Pacific'
  },
  serviceType: 'Aircraft Management',
  category: 'Aviation Services'
}, {
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': 'https://www.cosmoimageaviation.com/#camo-services',
  name: 'CAMO - Continuing Airworthiness Management',
  description: 'Continuing Airworthiness Management Organization services ensuring aircraft meet all regulatory requirements including airworthiness reviews, maintenance program management, and AD/SB compliance tracking.',
  provider: {
    '@id': 'https://www.cosmoimageaviation.com/#organization'
  },
  areaServed: {
    '@type': 'Place',
    name: 'Asia-Pacific'
  },
  serviceType: 'CAMO Services',
  category: 'Aviation Services'
}, {
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': 'https://www.cosmoimageaviation.com/#aircraft-charter',
  name: 'Aircraft Charter Solutions',
  description: 'Flexible charter solutions providing access to business jets and turboprops for corporate travel, special missions, and ad-hoc requirements across the Asia-Pacific region.',
  provider: {
    '@id': 'https://www.cosmoimageaviation.com/#organization'
  },
  areaServed: {
    '@type': 'Place',
    name: 'Asia-Pacific'
  },
  serviceType: 'Aircraft Charter',
  category: 'Aviation Services'
}];
serviceSchemas.forEach(schema => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
});
render(<AppRouter data-id="element-281" />, document.getElementById('root'));